import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1c0acc07"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ads-content"
};
const _hoisted_2 = ["href"];
import { ref } from 'vue';
import { getImgUrl } from '@/utils/common';
export default {
  __name: 'index',
  props: {
    ad: {
      type: Object,
      default: () => ({})
    }
  },
  setup(__props) {
    const props = __props;
    const show = ref(true);
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_el_image = _resolveComponent("el-image");
      return show.value ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "ads",
        onClick: _cache[1] || (_cache[1] = _withModifiers($event => show.value = false, ["stop"]))
      }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("span", {
        class: "close",
        onClick: _cache[0] || (_cache[0] = $event => show.value = false)
      }, [_createVNode(_component_Icon, {
        name: "el-icon-CircleClose"
      })]), _createElementVNode("a", {
        href: props.ad.courseLink,
        target: "_blank"
      }, [_createVNode(_component_el_image, {
        class: "img",
        src: props.ad.document ? _unref(getImgUrl)(props.ad.document) : ''
      }, null, 8, ["src"])], 8, _hoisted_2)])])) : _createCommentVNode("", true);
    };
  }
};